import React from "react";
import { Box } from '@curves/ui-base';
import { MeasurementClickableCard, MeasurementResultClickableCard } from "../Common";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import PercentIcon from "@mui/icons-material/Percent";
import FavoriteIcon from "@mui/icons-material/Favorite";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import DonutSmallIcon from "@mui/icons-material/DonutSmall";
import LocalDiningIcon from "@mui/icons-material/LocalDining";

const NOTIFY_CONTENT = {
	vfl: {
		1: { tip: "✨數值良好", desc: "正常範圍為 1–9，數值若高於 9，可能增加代謝症候群風險。" },
		2: { tip: "⚠️請留意代謝症候群風險", desc: "正常範圍為 1–9，數值接近上限，需留意代謝症候群風險。" },
		3: { tip: "⚡代謝症候群高風險", desc: "正常範圍為 1–9，數值高於正常範圍，代謝症候群風險偏高。建議諮詢醫師。" },
	},
	whr: {
		1: { tip: "✨數值良好", desc: "正常範圍為 0.75–0.85，數值若高於 0.85，可能提升心血管疾病風險。" },
		2: { tip: "⚠️請留意心血管疾病風險", desc: "正常範圍為 0.75–0.85，數值接近範圍邊界，需留意心血管疾病風險。" },
		3: { tip: "⚡心血管疾病高風險", desc: "正常範圍為 0.75–0.85，數值高於正常範圍，心血管疾病風險偏高。建議諮詢醫師。" },
	},
	smi: {
		1: { tip: "✨數值良好", desc: "正常範圍為 5.7–18.3 kg/m²，數值若低於 5.7 kg/m²，可能增加肌少症風險。" },
		2: { tip: "⚠️請留意肌少症風險", desc: "正常範圍為 5.7–18.3 kg/m²，數值接近下限，需留意肌少症風險。" },
		3: { tip: "⚡肌少症高風險", desc: "正常範圍為 5.7–18.3 kg/m²，數值低於正常範圍，肌少症風險偏高。建議諮詢醫師。" },
	},
	bmc: {
		1: { tip: "✨數值良好", desc: "正常範圍為 2.22–5.4 kg，數值若低於 2.22 kg，可能增加骨質疏鬆風險。" },
		2: { tip: "⚠️請留意骨質疏鬆風險", desc: "正常範圍為 2.22–5.4 kg，數值接近下限，需留意骨質疏鬆風險。" },
		3: { tip: "⚡骨質疏鬆高風險", desc: "正常範圍為 2.22–5.4 kg，數值低於正常範圍，骨質疏鬆風險偏高。建議諮詢醫師。" },
	},
};

const getNotifyContent = (metric, notifyType) => NOTIFY_CONTENT[metric]?.[notifyType] ?? NOTIFY_CONTENT[metric][1];

const ResearchParametersSection = ({ sourceData, onTrendLineClick }) => {
	const vflContent = getNotifyContent("vfl", sourceData?.notifyVFL);
	const whrContent = getNotifyContent("whr", sourceData?.notifyWHR);
	const smiContent = getNotifyContent("smi", sourceData?.notifySMI);
	const bmcContent = getNotifyContent("bmc", sourceData?.notifyBMC);

	return (
		<>
			<Box className="measurement-group-content--1">
				<MeasurementResultClickableCard
					className="measurement-group-content__item"
					name="內臟脂肪級別"
					value={sourceData?.vfl}
					unit=""
					icon={<FavoriteIcon />}
					onClick={() => onTrendLineClick(sourceData?.vflTrendType)}
					notifyType={sourceData?.notifyVFL}
					tip={vflContent.tip}
					desc={vflContent.desc}
				/>
				<MeasurementResultClickableCard
					className="measurement-group-content__item"
					name="腰臀比"
					value={sourceData?.whr}
					unit=""
					icon={<PercentIcon />}
					onClick={() => onTrendLineClick(sourceData?.whrTrendType)}
					notifyType={sourceData?.notifyWHR}
					tip={whrContent.tip}
					desc={whrContent.desc}
				/>
				<MeasurementResultClickableCard
					className="measurement-group-content__item"
					name="肌肉質量指數 (SMI)"
					value={sourceData?.skeletalMuscleIndex}
					unit="kg/m²"
					icon={<FitnessCenterIcon />}
					onClick={() => onTrendLineClick(sourceData?.skeletalMuscleIndexTrendType)}
					notifyType={sourceData?.notifySMI}
					tip={smiContent.tip}
					desc={smiContent.desc}
				/>
				<MeasurementResultClickableCard
					className="measurement-group-content__item"
					name="骨礦含量"
					value={sourceData?.bmc}
					unit="kg"
					icon={<DonutSmallIcon />}
					onClick={() => onTrendLineClick(sourceData?.bmcTrendType)}
					notifyType={sourceData?.notifyBMC}
					tip={bmcContent.tip}
					desc={bmcContent.desc}
				/>
			</Box>
			<Box className="measurement-group-content--2">
				<MeasurementClickableCard
					className="measurement-group-content__item"
					name="基礎代謝率"
					value={sourceData?.bmr}
					unit="kcal"
					icon={<LocalFireDepartmentIcon />}
					onClick={() => onTrendLineClick(sourceData?.bmrTrendType)}
				/>
				<MeasurementClickableCard
					className="measurement-group-content__item"
					name="建議攝取熱量"
					value={sourceData?.recommendedCaloricIntake}
					unit="kcal"
					icon={<LocalDiningIcon />}
					onClick={() => onTrendLineClick(sourceData?.rciTrendType)}
				/>
			</Box>
		</>
	);
};

export default ResearchParametersSection;
